import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/scss';

export default function (element, data) {
    const swiperContainer = element.querySelector('.block-swiper');
    const swiperWrapper = document.querySelector('.block-swiper .swiper-wrapper');
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    const nextBtn = element.querySelector(".swiper-button-next");
    const prevBtn = element.querySelector(".swiper-button-prev");

    const swiperOptions = {
        modules: [Autoplay, Navigation],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        breakpoints: {
            768: {
                spaceBetween: 40,
            },
        }
    };
    
    if (slides.length > 1 && slides.length < 8) {
        slides.forEach(slide => {
            const cloneSlide = slide.cloneNode(true);
            swiperWrapper.appendChild(cloneSlide);
        });
    }

    if (slides.length > 1 && nextBtn && prevBtn) {
        nextBtn.style.display = 'block';
        prevBtn.style.display = 'block';
    } else if (nextBtn && prevBtn) {
        nextBtn.style.display = 'none';
        prevBtn.style.display = 'none';
    }
    
    element.swiper = new Swiper(swiperContainer, swiperOptions);
};